import React, { useState } from "react";
import Modal from "../components/Modal";
import { useTranslation } from "react-i18next";

const Unlimited_integrations = () => {
  const { t, i18n } = useTranslation();
  const [language, setLenguage] = useState("es");
  const [isOpen, setIsOpen] = useState(false);

  const SVG_OVERLAY_URL = "https://img.invupos.com/clauweb/Hero/Vector%20128.svg";

  const LogoMarquee = ({
    speed = 48,     // mayor = más sutil/lento
    gapRem = 3,     // separación entre logos (rem)
  }) => {
    // Ajustes finos por marca (por si alguna es demasiado ancha/alta visualmente)
    // Puedes quitar/ajustar estas entradas si no las necesitas.
    const brandAdjust = {
      "Sushiexpress1.webp": "scale-90",
      "Elcosto.webp": "scale-90",
      "Grupotova.webp": "scale-90",
    };
  
    const logos = [
      // === 9 nuevos primero ===
      { src: "https://img.invupos.com/clauweb/Empresas/stevens.png", alt: "Stevens" },
      { src: "https://img.invupos.com/clauweb/Empresas/Powertranz.png", alt: "Powertranz" },
      { src: "https://img.invupos.com/clauweb/Empresas/Grand-deli-gourmet.png", alt: "Grand Deli Gourmet" },
      { src: "https://img.invupos.com/clauweb/Empresas/Olive-garden.png", alt: "Olive Garden" },
      { src: "https://img.invupos.com/clauweb/Empresas/sugoi.png", alt: "Sugoi" },
      { src: "https://img.invupos.com/clauweb/Empresas/Cafe%20duran.png", alt: "Café Durán" },
      { src: "https://img.invupos.com/clauweb/Empresas/Madison.png", alt: "Madison" },
      { src: "https://img.invupos.com/clauweb/Empresas/XING%20FU%20TANG.png", alt: "Xing Fu Tang" },
      { src: "https://img.invupos.com/clauweb/Empresas/Leto.png", alt: "Leto" },
  
      // === Los que ya tenías ===
      // { src: "https://img.invupos.com/clauweb/Partners/logos/cinnabon-1.webp", alt: "Cinnabon" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Sushiexpress1.webp", alt: "Sushi Express" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Elcosto.webp", alt: "El Costo" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Grupotova.webp", alt: "Grupo Tova" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/CredicorpBank_logo.webp", alt: "Credicorp Bank" },
      // { src: "https://img.invupos.com/clauweb/Partners/Tsugoi.webp", alt: "Tsugoi" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/FDCenter_logo.webp", alt: "FDCenter" },
      // { src: "https://img.invupos.com/clauweb/Partners/logos/Bravapizza_logo.webp", alt: "Brava Pizza" },
    ];
  
    // Duplicamos dentro de UNA sola pista para loop perfecto sin “salto”
    const track = [...logos, ...logos];
  
    return (
      <div
        className="relative w-full overflow-hidden py-10 group"
        // máscara sutil para entradas/salidas suaves
        style={{
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
          maskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
        }}
      >
        <style>{`
          @keyframes marqueeX {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .marquee-track {
            display: flex;
            align-items: center;
            width: max-content;
            animation: marqueeX var(--marquee-duration, 48s) linear infinite;
            will-change: transform;
          }
          .marquee-track > * + * { margin-left: ${gapRem}rem; } /* separación entre “cajas” */
          .paused { animation-play-state: paused; }
  
          /* Respeta reduce motion */
          @media (prefers-reduced-motion: reduce) {
            .marquee-track { animation: none !important; transform: none !important; }
          }
  
          /* Ajuste leve por viewport para elegancia */
          @media (min-width: 1024px) {
            .marquee-root { --marquee-duration: ${speed + 6}s; }
          }
          @media (max-width: 480px) {
            .marquee-root { --marquee-duration: ${Math.max(30, speed - 6)}s; }
          }
        `}</style>
  
        <div className="marquee-root">
          <div className={`marquee-track group-hover:paused`}>
            {track.map((logo, i) => {
              // detectar nombre de archivo para ajuste fino opcional
              const filename = logo.src.split("/").pop() || "";
              const tweak = Object.keys(brandAdjust).find(key =>
                filename.includes(key)
              );
              const scaleClass = tweak ? brandAdjust[tweak] : "";
  
              return (
                <div
                  key={i}
                  className="flex-shrink-0 flex items-center justify-center 
                             h-[68px] sm:h-[76px] lg:h-[86px]
                             w-[clamp(140px,12vw,240px)]" // caja uniforme
                >
                  <img
                    src={logo.src}
                    alt={logo.alt || ""}
                    loading="lazy"
                    className={`max-h-full max-w-full object-contain 
  
                      transition-all duration-300 ease-in-out
                      ${scaleClass}`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* <section className="bg-gradient-to-b bg-gradient-to-b from-[#040309] via-[#171635] to-[#2A255B]">
        <div className="px-4 py-28 mx-auto max-w-screen-xl sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 lg:gap-32 lg:grid-cols-2 items-center">
            <div className="relative overflow-hidden lg:order-last order-last flex flex-col rounded-3xl drop-shadow-[0_10px_20px_rgba(236,57,42,0.25)]">
              <img
                alt="Wallet Digital"
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/Integraciones-hero.webp"
                className="object-cover w-full h-full rounded-3xl"
              />
            </div>
            <div className="lg:py-28 text-left">
              <h1 className="text-6xl font-extrabold sm:text-8xl text-white">
                <span className="block">{t("clauintegrationsuppercase")}</span>
                <span
                  className="mt-4 w-full ml-auto px-12 py-4 rounded-r-full text-white lg:text-7xl text-5xl font-bold flex items-center justify-end"
                  style={{
                    background:
                      "linear-gradient(to right, white, #A9A8EE, #9290EA)",
                  }}
                >
                  {t("clauintegrationstitlespan")}
                </span>
              </h1>
              <p className="mt-8 text-gray-100 text-2xl w-full tracking-normal leading-relaxed">
                {t("clauintegrationsdescription")}
              </p>
              <div className="mt-8">
                <button
                  class="inline-block rounded-full border border-[#fff] bg-[#fff] px-16 py-4 text-lg font-medium text-[#1F2331] hover:bg-transparent hover:text-[#fff] focus:ring-3 focus:outline-hidden"
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  {t("clauintegrationscta")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}

<section className="relative w-full flex items-center overflow-hidden lg:pt-0 pt-10">
  
  
  <div className="w-full max-w-screen-2xl mx-auto px-6">
    
    {/* 👇 Cambiamos proporción del grid */}
    <div className="grid lg:grid-cols-[45%_55%] items-center gap-10">

      {/* LEFT */}
      <div className="max-w-3xl z-10">

        <h1 className="text-4xl md:text-5xl xl:text-[65px] font-semibold text-[#0B2B5C] leading-[1.15] mb-6">
        <span className="text-[#EC392A] font-extrabold">
          {t("INTEGRATIONS_HERO_TITLE_HIGHLIGHT")}
        </span>{" "}
        {t("INTEGRATIONS_HERO_TITLE_LINE2")}
        </h1>

        <p className="text-gray-600 text-base md:text-lg mb-8 max-w-2xl">
        {t("INTEGRATIONS_HERO_DESCRIPTION")}
        </p>

        <button 
          onClick={() => {
            setIsOpen(true);
          }}
        className="bg-[#E73829] hover:bg-[#ff5a4c] transition text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg">
        {t("INTEGRATIONS_HERO_BUTTON")}
        </button>
      </div>

      {/* RIGHT */}
      {/* <div className="relative flex justify-end">
        <img
          src="https://img.invupos.com/clauweb/Hero/Group%201597880418.png"
          alt="Clau App"
          className="w-[120%] max-w-none translate-x-10 drop-shadow-2xl"
        />
      </div> */}


<div className="relative flex justify-center lg:justify-center">

{/* 🎨 LÍNEAS */}
<img
  src="https://img.invupos.com/clauweb/Hero%20new/cover-img-clau-3.png"
  alt=""
  className="
    absolute top-0 
    lg:left-auto lg:right-0 lg:translate-x-10 mt-16
    w-[110%] sm:w-[115%] lg:w-[150%] max-w-none
    animate-lineDrawBlue
  "
/>

<img
  src="https://img.invupos.com/clauweb/Hero%20new/cover-img-clau-4.png"
  alt=""
  className="
    absolute top-0 
    lg:left-auto lg:right-0 lg:translate-x-10 mt-16
    w-[110%] sm:w-[115%] lg:w-[150%] max-w-none
    animate-lineDrawRed
  "
/>

{/* 🧱 IMAGEN 1 */}
<div className="relative w-[100%] sm:w-[50%] lg:w-[90%] mx-auto aspect-square overflow-hidden">
  <img
    src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/Integraciones-hero.webp"
    alt="Clau App"
    className="
      relative z-10
      mt-24
    opacity-0 animate-img1
    "
  />
</div>
</div>
    </div>
  </div>
</section>

      <div className="px-4 py-16 mx-auto  md:max-w-full lg:max-w-screen-2xl lg:px-8 lg:py-10">
        <div className="p-8 rounded-3xl sm:p-12 bg-[#F1F1F1]">
          <h2 className="text-4xl sm:text-5xl text-[#1d1d1f]">
            {t("clauintegrationpossectiontitle")}
          </h2>
          <div className="flex flex-col items-center justify-between lg:flex-row mt-8 rounded-3xl bg-[#F1F1F1] lg:gap-12">
            <div className="relative lg:w-1/2 mb-8 lg:mb-0 ">
              <img
                className="lg:w-full lg:h-[420px] rounded-2xl shadow-lg object-cover object-top"
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/API-Abierta.webp"
                alt="Combo del día"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl flex items-end justify-center p-4">
                <p className="text-white text-2xl font-semibold">
                  {t("clauintegrationposapicaption")}
                </p>
              </div>
            </div>

            <div className="lg:max-w-xl lg:pl-10 p-8">
              <ul className="space-y-4 text-gray-700 text-xl list-disc">
                <li>
                  <span className="font-bold ">
                    {t("clauintegrationposoverview")}
                  </span>
                </li>
                <li>
                  <span className="font-bold">
                    {t("clauintegrationposlimitless")}
                  </span>
                </li>
                <li>
                  <span className="font-bold">
                    {t("clauintegrationposautomated")}
                  </span>
                </li>
                <li>
                  <span className="font-bold">
                    {t("clauintegrationposrealtime")}
                  </span>
                </li>
                <li>
                  <span className="font-bold">
                    {t("clauintegrationposeasy")}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section>
<div className="mt-10 sm:mt-16 mx-auto max-w-screen-2xl">
          <LogoMarquee speed={42} gapRem={2} />
        </div>
      </section>

      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-2xl  lg:px-8 lg:py-20">
        <h2 className="text-5xl sm:text-6xl text-[#1d1d1f] py-10 mb-8 md:mb-0 text-left md:text-center lg:text-left md:mb-6 lg:mb-0">
          {t("clauintegrationsecosystemtitle1")}{" "}
          <span className="hidden lg:inline"></span>
          <span className="text-[#FE7066]">
            {t("clauintegrationsecosystemtitle2")}
          </span>
        </h2>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-5">
          <div className=" lg:px-8 relative md:col-span-2 lg:col-span-2 items-center flex  justify-center md:justify-center">
            <div className="max-w-xl relative w-full h-[385px] lg:ml-0 ml-10">
              <div className="absolute top-[-40px] left-[-40px] w-full h-full bg-[#FFE9E9] rounded-[2rem] z-0"></div>
              <div className="absolute top-[-20px] left-[-20px] w-full h-full bg-[#F58F87] rounded-[2rem] z-0"></div>

              <div className="relative bg-[#FE7066] text-white rounded-[2rem] p-6 w-full h-full z-10 shadow-md">
                <div className="flex justify-between items-start">
                  <h2 className="text-4xl font-bold leading-tight">
                    {t("clauintegrationallinonetitle")}
                  </h2>
                  <div className="bg-white text-rose-500 rounded-full p-2">
                    <svg
                      className="w-8 h-8"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17 7l-10 10M17 17V7H7"
                      />
                    </svg>
                  </div>
                </div>
                <p className="mt-4 text-white/90 leading-relaxed text-2xl">
                  {t("clauintegrationallinonedescription")}
                </p>
              </div>
            </div>
          </div>
          <div className="grid gap-6 md:col-span-2 lg:col-span-3">
            <div>
              <img
                className="w-full h-auto"
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/Ecosistema.webp"
                alt="Promoción"
              />
            </div>
          </div>
        </div>
        {/* <section class="px-4 py-12 mx-auto max-w-7xl">
  <div class="grid grid-cols-2 gap-10 text-center lg:grid-cols-9">
    <div class="flex items-center justify-center">
      <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Invu-logo.png" class="block object-contain h-16" />
    </div>
    <div class="flex items-center justify-center">
      <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Shipday-logo.png" class="block object-contain h-16" />
    </div>
    <div class="flex items-center justify-center">
      <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Powertranz-logo.png" class="block object-contain h-16" />
    </div>
    <div class="flex items-center justify-center">
      <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Picker-logo.png" class="block object-contain h-16" />
    </div>
    <div class="flex items-center justify-center">
      <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Yappy-logo.png" class="block object-contain h-16" />
    </div>
    <div class="flex items-center justify-center">
      <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Uber-direct-logo.png" class="block object-contain h-16" />
    </div>
    <div class="flex items-center justify-center">
      <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Mastercard-logo.png" class="block object-contain h-16" />
    </div>
    <div class="flex items-center justify-center">
      <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Visa-logo.png" class="block object-contain h-16" />
    </div>
    <div class="flex items-center justify-center">
      <img src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/ASAP-logo.png" class="block object-contain h-16" />
    </div>
  </div>
</section> */}
        <section class="px-4 py-12 mx-auto max-w-7xl">
          <div class="grid grid-cols-2 sm:grid-cols-5 lg:grid-cols-8 gap-10 justify-items-center items-center">
            <a
              href="https://invupos.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Invu-logo.png"
                alt="Invu POS"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://www.baccredomatic.com/es-pa"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Unlimited%20integrations/BAC_Credomatic_befsv4.png"
                alt="BAC Credomatic"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://powertranz.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Powertranz-logo.png"
                alt="Powertranz"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://picker.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Picker-logo.png"
                alt="Picker"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://yappy.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Yappy-logo.png"
                alt="Yappy Comercial"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://mastercard.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Mastercard-logo.png"
                alt="Mastercard"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://visa.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Visa-logo.png"
                alt="Visa"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://asap.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/ASAP-logo.png"
                alt="ASAP"
                class="h-16 object-contain"
              />
            </a>

            <a
              href="https://authorize.net"
              class="lg:col-start-3"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Unlimited%20integrations/authorize-net_1_hyrzbz.png"
                alt="Authorize.net"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://stripe.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Unlimited%20integrations/stripe_logo_qws2sd.png"
                alt="Stripe"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://direct.uber.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Uber-direct-logo.png"
                alt="Uber Direct"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://shipday.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Integraciones%20sin%20limites/logos/Shipday-logo.png"
                alt="Shipday"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://www.credicorpbank.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Unlimited%20integrations/BAC_Credomatic_befsv4.png"
                alt="Credicorp Bank"
                class="h-16 object-contain"
              />
            </a>
            <a
              href="https://www.bancolombia.com/personas"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.invupos.com/clauweb/Unlimited%20integrations/Bancolombia_1_aci3ox.png"
                alt="Bancolombia"
                class="h-16 object-contain"
              />
            </a>
          </div>
        </section>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12 text-center">
          <div className="bg-[#F8F8F8] rounded-2xl p-8">
            <h4 className="text-[#FE7066] font-bold mb-2 text-2xl break-words max-w-[220px] mx-auto">
              {t("clauintegrationdeliverytitle")}
            </h4>
            <p className="text-gray-600 text-lg mt-3">
              {t("clauintegrationdeliverydescription")}
            </p>
          </div>
          <div className="bg-[#F8F8F8] rounded-2xl p-8">
            <h4 className="text-[#FE7066] font-bold mb-2 text-2xl break-words max-w-[220px] mx-auto">
              {t("clauintegrationposystemstitle")}
            </h4>
            <p className="text-gray-600 text-lg mt-3">
              {t("clauintegrationposystemsdescription")}
            </p>
          </div>
          <div className="bg-[#F8F8F8] rounded-2xl p-8">
            <h4 className="text-[#FE7066] font-bold mb-2 text-2xl break-words max-w-[250px] mx-auto">
              {t("clauintegrationapiflexibilitytitle")}
            </h4>
            <p className="text-gray-600 text-lg mt-3">
              {t("clauintegrationapiflexibilitydescription")}
            </p>
          </div>
        </div>
      </div>


      <section className="w-full bg-white pt-24 pb-16 px-6 lg:px-24 lg;mt-0 mb-24">
      {/* 1. Contenedor de Altura Completa (overflow-visible) */}
      <div className="max-w-screen-2xl mx-auto relative flex flex-col lg:flex-row items-center justify-between rounded-[40px] p-8 lg:p-20 shadow-sm border border-gray-100 overflow-visible">
        
        {/* SVG de Fondo (El Overlay) */}
        <div className="absolute inset-0 z-0 opacity-40 pointer-events-none">
          <img 
            src={SVG_OVERLAY_URL}
            alt="Fondo decorativo" 
            className="w-full h-full object-cover"
          />
        </div>

        {/* --- Columna Izquierda: El iPhone desbordado --- */}
        {/* 2. Contenedor relativo de altura completa para posicionar */}
        <div className="relative z-20 w-full lg:w-1/2 flex justify-center lg:justify-start h-[300px] lg:h-auto mb-16 lg:mb-0">
          {/* 3. El teléfono real: Posicionado Absoluto para desbordar */}
          <div className="absolute top-0 transform -translate-y-1/3 lg:-translate-y-1/2 w-[280px] md:w-[320px]  drop-shadow-2xl">
            <img 
              src="https://img.invupos.com/clauweb/Productos%20NFC/CafeDuranMockup.webp"
              alt="Café Duran Mockup App"
              className="w-full h-auto"
            />
          </div>
        </div>

        {/* --- Columna Derecha: Texto e Integraciones --- */}
        <div className="relative z-10 w-full  text-right space-y-6 ml-auto">
        <p class="text-4xl text-[#1d1d1f] md:text-5xl">
                  {t("LOYALTY_TITLE")}
                </p>
  
  <p className="text-xl text-gray-600 max-w-xl ml-auto leading-relaxed">
  {t("LOYALTY_DESCRIPTION")}
  </p>
  <button className="mt-6 inline-block rounded-full border border-[#FE7066] bg-[#E73829] hover:bg-[#ff5a4c] lg:px-12 px-8 py-3 text-sm md:text-lg font-medium text-white hover:bg-transparent hover:text-[#FFF] focus:ring-3 focus:outline-hidden"
                    onClick={() => {
                      setIsOpen(true);
                    }}
                  >
                    {t("LOYALTY_BUTTON")}
                  </button>
        </div>
      </div>
    </section>
      {isOpen && <Modal setIsOpen={setIsOpen} />}
    </>
  );
};

export default Unlimited_integrations;